import { render, staticRenderFns } from "./Blocklist.vue?vue&type=template&id=20153858&"
import script from "./Blocklist.vue?vue&type=script&lang=js&"
export * from "./Blocklist.vue?vue&type=script&lang=js&"
import style0 from "./Blocklist.vue?vue&type=style&index=0&id=20153858&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports